module.exports = __webpack_public_path__ + "0499741e1764f9488ce569ffdfa2298d.svg";